// Small FIFO queue that caps concurrent SDK calls to MAX_CONCURRENT.
//
// Every SDK call in @induz/sdk opens its own WebSocket via initTdx() — so when
// a dashboard mounts ~14 cards at once, the browser tries to negotiate ~14
// concurrent connections. Funnelling the calls through this queue keeps a
// small handful of sockets in flight at a time and serialises the rest.

const MAX_CONCURRENT = 4;

let active = 0;
const pending = [];

function drain() {
  while (active < MAX_CONCURRENT && pending.length) {
    const { fn, resolve, reject } = pending.shift();
    active++;
    Promise.resolve()
      .then(fn)
      .then(
        (v) => { active--; resolve(v); drain(); },
        (e) => { active--; reject(e); drain(); },
      );
  }
}

export function queueSdkCall(fn) {
  return new Promise((resolve, reject) => {
    pending.push({ fn, resolve, reject });
    drain();
  });
}

// Wrap an async fn so each invocation is enqueued instead of running
// immediately. The returned fn has the same signature as the original.
export function queued(sdkFn) {
  return (...args) => queueSdkCall(() => sdkFn(...args));
}
